import { useTranslation } from 'react-i18next';

import natalia from '@/assets/images/form-and-reviews/natalia.webp';
import kate from '@/assets/images/form-and-reviews/kate.webp';
import maxim from '@/assets/images/form-and-reviews/maxim.webp';

import { renderMultilineText } from '@/utils/renderMultilineText';

import { Container } from '@/components/Container';
import { LeadForm } from '@/components/LeadForm';
import { Title } from '@/components/Title';
import { ReviewSlide } from '@/components/ReviewSlide';
import { Carousel } from '@/components/Carousel';

import styles from './FormAndReviews.module.scss';

const REVIEWS_PHOTOS = [natalia, kate, maxim];

export function FormAndReviews() {
  const { t } = useTranslation('formAndReviews');

  const reviewsLocales = t('reviews', { returnObjects: true }) as {
    name: string;
    text: string;
  }[];
  const reviews = REVIEWS_PHOTOS.map((photo, index) => ({
    photo,
    name: reviewsLocales[index].name,
    text: reviewsLocales[index].text,
  }));

  const reviewSlides = reviews.map((review, index) => (
    <ReviewSlide key={index} photo={review.photo} name={review.name}>
      {renderMultilineText(review.text)}
    </ReviewSlide>
  ));

  return (
    <section className={styles.formAndReviews} id="reviews">
      <Container className={styles.formAndReviews__container}>
        <div className={styles.formAndReviews__form}>
          <LeadForm />
        </div>
        <div className={styles.formAndReviews__reviews}>
          <Title className={styles.formAndReviews__reviewsTitle}>{t('title')}</Title>
          <Carousel
            theme="dark"
            id="reviews-carousel"
            spaceBetweenSlides={20}
            slides={reviewSlides}
          />
        </div>
      </Container>
    </section>
  );
}
